import { createSlice } from '@reduxjs/toolkit'
import { createValuationPdf, getSignedUrl } from './thunks'
import { ValuationPdf } from '../../@types/valuationPdf'
import { Resource } from '../../@types/resource'
import { Status } from '../../@types/status'

export const initialState: Resource<ValuationPdf> = {
  status: Status.LOADING,
}

const valuationPdfSlice = createSlice({
  name: 'valuationPdf',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createValuationPdf.pending, (state) => {
      return { ...state, status: Status.LOADING }
    })

    builder.addCase(createValuationPdf.fulfilled, (state, { payload }) => {
      if (!payload) {
        return state
      }

      return {
        ...state,
        status: Status.SUCCESS,
        data: {
          pdfId: payload.pdfId,
        },
      }
    })

    builder.addCase(createValuationPdf.rejected, (state) => {
      return { ...state, status: Status.ERROR }
    })

    builder.addCase(getSignedUrl.pending, (state) => {
      return { ...state, status: Status.LOADING }
    })

    builder.addCase(getSignedUrl.fulfilled, (state, { payload }) => {
      return {
        ...state,
        status: Status.SUCCESS,
        data: {
          url: payload.signedPdfUrl,
        },
      }
    })

    builder.addCase(getSignedUrl.rejected, (state) => {
      return { ...state, status: Status.ERROR }
    })
  },
})

export default valuationPdfSlice.reducer
